import { Group } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';

import { ApiEstimationStage } from '@/api/schema/data-contracts';
import ViewIcon from '@/assets/view-icon.svg?react';
import { EstimationStageBadge } from '@/components/atoms/EstimationStageBadge';
import type { ExportableDataTableColumn } from '@/components/organism/DataTable/model';
import { INDEX_COLUMN_WIDTH } from '@/components/organism/DataTable/model';
import { UserFullName } from '@/components/UserFullName';
import { dateFormat } from '@/constants';
import type { MessageType } from '@/hooks/messages';
import type { EstimationVersion } from '@/types';

import type { EstimationVersionsMessages } from './messages';

const renderActions = (record: EstimationVersion) => (
  <Group gap={4} justify='right' wrap='nowrap'>
    <Link to='/estimation/detail/$estimationId' params={{ estimationId: record.estimationId }}>
      {record.status === ApiEstimationStage.IN_CREATION ||
      record.status === ApiEstimationStage.IN_PROCESS ? (
        <IconEdit size={16} />
      ) : (
        <ViewIcon />
      )}
    </Link>
  </Group>
);

export const columnsConfiguration = (
  messages: MessageType<typeof EstimationVersionsMessages>,
): ExportableDataTableColumn<EstimationVersion>[] => [
  {
    accessor: 'index',
    title: '#',
    width: INDEX_COLUMN_WIDTH,
  },
  {
    accessor: 'versionName',
    title: messages.versionName(),
    ellipsis: true,
    render: (item) => <p className='truncate'>{item.versionName}</p>,
  },
  {
    accessor: 'status',
    title: messages.status(),
    render: (record) => <EstimationStageBadge stage={record.status} />,
  },
  {
    accessor: 'lastUpdatedAt',
    title: messages.lastUpdated(),
    noWrap: true,
    render: (record) => record.createdAt.local().format(dateFormat),
  },
  {
    accessor: 'lastUpdatedBy',
    title: messages.lastUpdatedBy(),
    noWrap: true,
    render: (record) => <UserFullName userId={record.lastUpdatedBy} />,
  },

  {
    accessor: 'createdAt',
    title: messages.createdAt(),
    noWrap: true,
    render: (record) => record.createdAt.local().format(dateFormat),
  },
  {
    accessor: 'createdBy',
    title: messages.createdBy(),
    noWrap: true,
    render: (record) => <UserFullName userId={record.createdBy} />,
  },
  {
    accessor: 'estimate',
    title: messages.estimate(),
    noWrap: true,
  },
  {
    accessor: 'actions',
    title: '',
    width: '0%',
    render: renderActions,
    excludeFromExport: true,
  },
];
